module.exports = __webpack_public_path__ + "static/media/IMG_4276.f9254817.PNG";